import { createContext, useContext, ReactNode, useState } from "react";

// Define role types
export type Role = "learn" | "prism";

// Define context value type
interface RoleContextType {
  role: Role;
  setRole: (newRole: Role) => void;
}

// Create context with default value as undefined
export const RoleContext = createContext<RoleContextType>({
  role: window.location.pathname.includes("prism") ? "prism" : "learn",
  setRole: () => {},
});

// Custom hook to use the role
export const useRole = (): Role => {
  const { role } = useContext(RoleContext);
  if (!role) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return role;
};

// Provider component
interface RoleProviderProps {
  children: ReactNode;
}

export const RoleProvider = ({ children }: RoleProviderProps) => {
  const [role, setRole] = useState<Role>(
    window.location.pathname.includes("prism") ? "prism" : "learn"
  );

  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};
